import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EnvironmentService } from '@galaxy/core';
import { ProductAnalyticsService } from '@vendasta/product-analytics';

@Component({
  selector: 'app-base',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'shoppable-feed-client';

  constructor(
    private snowplowTracker: ProductAnalyticsService,
    private readonly environmentService: EnvironmentService,
  ) {}

  ngOnInit(): void {
    this.snowplowTracker.initialize({
      environment: this.environmentService.getEnvironment(),
      projectUUID: '9c5ce4b8-19cf-45c5-980b-449818d0d975',
    });
  }
}
